// extracted by mini-css-extract-plugin
export default {"tag":"TagColumn_tag__MeiHH"};